//Generated File 
export default class ConstantViewNames{
	static readonly AUTO_SYSTEM_ACTION = `autoSystemAction`;
	static readonly BIZ_REQUEST_VIEW = `bizRequestView`;
	static readonly COMPOSITE_DIMENSION_LIST_PREFIX = `composite`;
	static readonly DISTRIBUTE_CONTRACTING_COST_TASK_VIEW = `distributeContractingCostOnRealEstateTask`;
	static readonly DMS_DOCUMENTS_ARCHIVE = `RelatedDMSDocuments`;
	static readonly EMPLOYEE_APPROVALS_SCREEN_NAME = `employeeApprovals`;
	static readonly EMPLOYEE_NOTIFICATIONS_SCREEN_NAME = `employeeNotifications`;
	static readonly EMPLOYEE_READ_NOTIFICATIONS_SCREEN_NAME = `employeeReadNotifications`;
	static readonly END_STOCK_TAKING_TASKS = `EndStockTakingTask`;
	static readonly LEDGER_TRANS_SCREEN_NAME = `LedgerTrans`;
	static readonly PENDING_SYSTEM_ACTION = `pendingSystemAction`;
	static readonly PENDING_TASKS_VIEW = `pendingTasks`;
	static readonly PENDING_TASK_SCHEDULES = `pendingTaskSchedules`;
	static readonly QUEUED_TASK_SCHEDULES = `queuedTaskSchedules`;
	static readonly RECORD_AUDIT_TRAIL = `recordAuditTrail`;
	static readonly RECORD_DETAILED_AUDIT_TRAIL = `recordDetailedAuditTrail`;
	static readonly RECORD_INSTALLMENT_PAYMENTS = `installmentPayments`;
	static readonly RELATED_DETAILED_REMARKS = `RelatedDetailedRemarks`;
	static readonly RELATED_LGTSTATUSENTRIES = `RelatedLGTStatusEntries`;
	static readonly RELATED_MEETING_REMARKS = `RelatedMeetingRemarks`;
	static readonly RELATED_QUESTIONAIRS = `RelatedQuestions`;
	static readonly RELATED_REMARKS = `RelatedRemarks`;
	static readonly RELATED_REVISION_DOCS = `RelatedRevisionDocs`;
	static readonly REPORT_CATALOGUE_SCREEN_NAME = `ReportCatalogue`;
	static readonly SAVED_BUSINESS_REQUEST_VIEW = `SavedBusinessRequestView`;
	static readonly SENT_ENTITIES_TO_ANOTHER_SERVER = `sentEntitiesToAnotherServer`;
	static readonly SFDA_RSD_DOC_STATUS = `SFDARSDDocStatus`;
	static readonly SFDA_RSD_INCOMING_DISPATCHES = `SFDARSDIncomingDispatch`;
	static readonly SFDA_RSD_LINE_ERRORS = `SFDARSDLineError`;
	static readonly SFDA_RSD_REPORT_TASKS = `SFDARSDReportTask`;
	static readonly STOCK_AGES_TASK = `StockAgesTask`;
	static readonly TECHNICIAN_APPOINTMENT_CREATOR = `TechnicianAppointmentCreator`;
	static readonly UNMATCHED_DEBT_AGES = `unmatchedDebtAges`;
	static readonly WEB_ENGAGE_SENT_EVENTS = `webEngageSentEvents`;
}
